"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var Theme_1 = require("../Theme");
var basic_1 = require("orbiter-core/src/basic");
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.imageStyling = function (theme) {
            var initialStyling = function (t) {
                return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                align-self: center;\n                object-fit: contain;\n            "], ["\n                align-self: center;\n                object-fit: contain;\n            "])));
            };
            return [initialStyling(theme), _this.props.imageStyle !== undefined ? _this.props.imageStyle(theme) : undefined];
        };
        _this.titleStyling = function (theme) {
            var initialStyling = function (th) {
                return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                margin: ", ";\n                margin-inline-start: 0;\n                margin-inline-end: 0;\n                font-size: ", " !important;\n                font-family: ", " !important;\n                line-height: ", " !important;\n            "], ["\n                margin: ", ";\n                margin-inline-start: 0;\n                margin-inline-end: 0;\n                font-size: ", " !important;\n                font-family: ", " !important;\n                line-height: ", " !important;\n            "])), Theme_1.applyTheme(theme, function (t) { return t.margin.smallMargin; }), Theme_1.applyTheme(theme, function (t) { return t.font.fontSize.h1; }), Theme_1.applyTheme(theme, function (t) { return t.font.fontFamily.h1; }), Theme_1.applyTheme(theme, function (t) { return t.font.lineHeight.h1; }));
            };
            return [initialStyling(theme), _this.props.titleStyle !== undefined ? _this.props.titleStyle(theme) : undefined];
        };
        _this.contentStyling = function (theme) {
            var initialStyling = function (th) {
                return core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                margin: ", ";\n                font-size: ", " !important;\n                font-family: ", " !important;\n                line-height: ", " !important;\n            "], ["\n                margin: ", ";\n                font-size: ", " !important;\n                font-family: ", " !important;\n                line-height: ", " !important;\n            "])), Theme_1.applyTheme(theme, function (t) { return t.margin.smallMargin; }), Theme_1.applyTheme(theme, function (t) { return t.font.fontSize["default"]; }), Theme_1.applyTheme(theme, function (t) { return t.font.fontFamily["default"]; }), Theme_1.applyTheme(theme, function (t) { return t.font.lineHeight["default"]; }));
            };
            return [initialStyling(theme), _this.props.contentStyle !== undefined ? _this.props.contentStyle(theme) : undefined];
        };
        _this.cardStyling = function (theme) {
            var cardClick = false;
            if (_this.props.fullCardClick !== undefined) {
                cardClick = _this.props.fullCardClick;
            }
            var initialStyling = function (th) {
                return core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                margin: ", ";\n                ", ";\n                \n            "], ["\n                margin: ", ";\n                ", ";\n                \n            "])), Theme_1.applyTheme(theme, function (t) { return t.margin.smallMargin; }), _this.props.linkTitle !== undefined && _this.props.onClick !== undefined && cardClick ? '&:hover{ cursor: pointer; }' : '');
            };
            return [initialStyling(theme), _this.props.cardStyle !== undefined ? _this.props.cardStyle(theme) : undefined];
        };
        _this.centeredStyling = function (theme) {
            if (_this.props.center) {
                return core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            "], ["\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            "])));
            }
            else {
                return undefined;
            }
        };
        _this.noMarginPaddingStyling = function (theme) {
            return core_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            margin: 0 !important;\n            padding: 0 !important;\n        "], ["\n            margin: 0 !important;\n            padding: 0 !important;\n        "])));
        };
        _this.rowStyling = function (theme) {
            return core_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            margin: 0 !important;\n            padding: 0 !important;\n            height: 100%;\n        "], ["\n            margin: 0 !important;\n            padding: 0 !important;\n            height: 100%;\n        "])));
        };
        return _this;
    }
    Card.prototype.onClick = function (e) {
        e.stopPropagation();
        basic_1.inu(this.props.onClick, function (a) { return a(); });
    };
    return Card;
}(React.Component));
exports.Card = Card;
var HorizontalCard = /** @class */ (function (_super) {
    __extends(HorizontalCard, _super);
    function HorizontalCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.imageColSize = _this.props.ImageColSize !== undefined ? _this.props.ImageColSize : 4;
        _this.buttonStyling = function (theme) {
            return core_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            margin-top: ", ";\n            // float: right;\n        "], ["\n            margin-top: ", ";\n            // float: right;\n        "])), Theme_1.applyTheme(theme, function (t) { return t.margin.mediumMargin; }));
        };
        _this.imageContainerStyling = function (theme) {
            var initialStyling = function (t) {
                return core_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                display: flex;\n                align-content: center;\n                \n            "], ["\n                display: flex;\n                align-content: center;\n                \n            "])));
            };
            return [initialStyling(theme), _this.props.imageContainerStyle !== undefined ? _this.props.imageContainerStyle(theme) : undefined];
        };
        _this.contentContainerStyling = function (theme) {
            var initialStyling = function (t) {
                return core_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n                // display: flex;\n            "], ["\n                // display: flex;\n            "])));
            };
            return [initialStyling(theme), _this.props.contentContainerStyle !== undefined ? _this.props.contentContainerStyle(theme) : undefined];
        };
        _this.verticalAlignStyling = function (theme) {
            var initialStyling = function (t) {
                return core_1.css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            "], ["\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            "])));
            };
            return [initialStyling(theme), _this.props.verticalAlignContentStyle !== undefined ? _this.props.verticalAlignContentStyle(theme) : undefined];
        };
        _this.contentColSize = function () {
            if (basic_1.isDefined(_this.props.imageSrc)) {
                return _this.props.ImageColSize !== undefined ? 12 - _this.props.ImageColSize : 8;
            }
            else {
                return 12;
            }
        };
        return _this;
    }
    return HorizontalCard;
}(Card));
exports.HorizontalCard = HorizontalCard;
var VerticalCard = /** @class */ (function (_super) {
    __extends(VerticalCard, _super);
    function VerticalCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonStyling = function (theme) {
            return core_1.css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n            position: absolute;\n            right: 0;\n            margin-right: ", ";\n            top: 0;\n        "], ["\n            position: absolute;\n            right: 0;\n            margin-right: ", ";\n            top: 0;\n        "])), Theme_1.applyTheme(theme, function (t) { return t.margin.mediumMargin; }));
        };
        return _this;
    }
    return VerticalCard;
}(Card));
exports.VerticalCard = VerticalCard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=card.js.map